require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-top-5-seo-trends-2019.json") })
        }
      }, "path---tapd-in-top-5-seo-trends-2019");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-top-5-seo-trends-2019!./.cache/json/tapd-in-top-5-seo-trends-2019.json
// module id = 875
// module chunks = 231608221292675